import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HelpBoxComponent } from './help-box.component';
import { ButtonModule } from '@components/button/button.module';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule,
    RouterModule,
  ],
  declarations: [HelpBoxComponent],
  exports: [HelpBoxComponent]
})
export class HelpBoxModule {}
